import { JSONObject, LayoutObject } from '../../types/types';
import { toFiniteNumber } from '../toFiniteNumber';
import { getMatrixPlacement } from './getMatrixPlacement';

// Existing objects lying (even partially) under the rows × columns grid the
// dialog values describe. The grid is collapsed to its bounding rect — the
// inner gaps count as matrix space, same as the old Manager. Touching edges
// are not an overlap.
export const getMatrixOverlappingObjects = (
  matrixValues: JSONObject,
  objects: LayoutObject[]
): LayoutObject[] => {
  const { rows, columns, width, height, gapX, gapY, startX, startY } =
    getMatrixPlacement(matrixValues);

  const matrixRight = startX + columns * width + (columns - 1) * gapX;
  const matrixBottom = startY + rows * height + (rows - 1) * gapY;

  return objects.filter((object) => {
    const x = toFiniteNumber(object.x, 0);
    const y = toFiniteNumber(object.y, 0);
    const right = x + toFiniteNumber(object.width, 0);
    const bottom = y + toFiniteNumber(object.height, 0);

    return x < matrixRight && right > startX && y < matrixBottom && bottom > startY;
  });
};
